import { render } from "./ClustersSidebar.vue?vue&type=template&id=c733cf0c&ts=true"
import script from "./ClustersSidebar.vue?vue&type=script&lang=ts"
export * from "./ClustersSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__